import ForgotPassword from "views/ForgotPasswordView";

export default function Page() {
  return (
    <>
      <ForgotPassword />
    </>
  );
}
